omadapp.controllers.scenes.common_methods = {
    heredar: function(obj) {
    	obj = obj||omadapp.controllers.scenes.common_methods
        var comunes = obj
        this.super = this.super || {}
        for (var n in comunes) {
            trace (n)
            if (!this[n]) {
                this[n] = comunes[n]
            } else {
                this.super[n] = comunes[n]
            }
        }
    },
  
}